import { switchMap } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { SymbolLpAction } from '@cbridge-packages/symbol-lp';
import { InfinityDataGridAction } from '@cbridge-modules/infinity-data-grid';

export const reloadSymbolLpListEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    SymbolLpAction.reload,
    SymbolLpAction.create.done,
    SymbolLpAction.update.done,
    SymbolLpAction.remove.done,
    SymbolLpAction.bulkUpdate.done,
    SymbolLpAction.bulkRemove.done,
  ),
  switchMap(() => {
    return [
      InfinityDataGridAction.refreshData(),
    ];
  }),
);
